import { formatIntegerIN, formatMoneyExact } from '../lib/format';

interface ReportingKpiValues {
  budget: number;
  reach: number;
  engagement: number;
}

// Complete figures behind the compact Reporting KPI tiles, keyed by tile label.
export function reportingKpiTooltips({ budget, reach, engagement }: ReportingKpiValues) {
  return {
    'Campaign Budget': budget > 0 ? formatMoneyExact(budget) : undefined,
    Views: reach > 0 ? formatIntegerIN(reach) : undefined,
    Engagement: engagement > 0 ? `${engagement.toFixed(2)}%` : undefined,
  };
}
